import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shortcutBadge"]
  static values = {
    key: String
  }

  declare readonly shortcutBadgeTargets: HTMLElement[]
  declare readonly hasKeyValue: boolean
  declare readonly keyValue: string

  connect() {
    if (this.isMobileOrTablet()) {
      // Mobile devices already have !hidden class, do nothing
      return
    }
    
    // For desktop devices, remove the !hidden class
    this.shortcutBadgeTargets.forEach(badge => {
      badge.classList.remove('!hidden')
      
      // If this badge has a key value attribute, format it properly
      const keyValue = badge.getAttribute('data-key-value')
      if (keyValue) {
        badge.textContent = this.formatKeyboardShortcut(keyValue)
      }
    })
  }

  formatKeyboardShortcut(key: string): string {
    // If on Mac, use ⌘, otherwise use Ctrl
    return this.isMac() ? `⌘${key}` : `Ctrl+${key}`
  }

  isMobileOrTablet(): boolean {
    // Check for touch capability
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    // Check for mobile/tablet userAgent patterns
    const userAgent = navigator.userAgent.toLowerCase()
    const isMobile = /iphone|ipod|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(userAgent)
    const isTablet = /ipad|android(?!.*mobile)|tablet|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP)))/.test(userAgent)

    return hasTouch && (isMobile || isTablet)
  }

  isMac(): boolean {
    const platform = navigator.platform.toLowerCase()
    const userAgent = navigator.userAgent.toLowerCase()
    
    return platform.includes('mac') || 
           userAgent.includes('macintosh') || 
           userAgent.includes('darwin')
  }
}
